import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 816.000000 1440.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1440.000000) scale(0.100000,-0.100000)">

<path d="M4860 9892 c0 -5 7 -15 15 -22 8 -6 23 -36 35 -66 25 -67 27 -208 5
-303 -43 -183 -198 -414 -427 -637 -170 -166 -271 -247 -623 -504 -423 -308
-558 -441 -616 -606 -39 -109 -17 -243 54 -336 61 -80 186 -165 161 -110 -4 9
-9 38 -12 63 -10 122 75 205 513 495 408 270 603 430 816 668 55 61 85 103 82
113 -4 9 -9 11 -15 5 -15 -15 -90 7 -110 32 -10 11 -18 29 -18 39 0 9 -4 17
-10 17 -5 0 -10 5 -10 11 0 19 -63 69 -75 59 -14 -12 -25 -3 -25 21 0 10 -10
21 -22 25 -50 15 -51 25 -10 68 62 65 125 145 189 236 132 191 174 297 181
466 4 91 1 122 -14 165 -10 30 -18 57 -19 61 0 11 -45 50 -45 40z"/>
<path d="M5156 8652 c-63 -131 -242 -332 -420 -470 -144 -113 -396 -279 -646
-427 -131 -77 -316 -204 -372 -254 -95 -86 -111 -172 -46 -247 32 -36 95 -74
123 -74 13 0 15 8 9 48 l-6 48 61 44 c33 24 170 107 303 185 266 154 401 241
571 368 114 85 328 288 326 310 0 9 -2 9 -6 0 -3 -10 -8 -9 -20 2 -8 8 -25 15
-38 15 -33 0 -77 18 -70 29 3 5 -4 12 -15 16 -16 5 -18 10 -10 24 5 10 7 21 3
24 -3 4 30 46 74 94 44 48 98 115 120 148 45 67 86 145 80 151 -2 2 -11 -13
-21 -34z"/>
<path d="M5225 8308 c-50 -96 -99 -162 -200 -268 -55 -57 -84 -93 -64 -78 24
18 40 24 50 17 11 -7 12 -9 0 -9 -11 0 -11 -3 -1 -15 8 -9 9 -15 2 -15 -6 0
-14 5 -17 10 -9 14 -21 12 -39 -6 -9 -8 -20 -12 -26 -9 -6 3 -34 -13 -63 -38
-144 -120 -338 -251 -637 -427 -305 -179 -335 -199 -335 -229 0 -64 111 -82
225 -36 369 150 812 439 961 626 27 34 29 42 18 56 -10 12 -10 15 -1 9 6 -4
12 -2 12 3 0 19 -63 40 -80 27 -9 -7 -8 -3 3 10 15 18 16 24 4 47 -8 15 -18
23 -23 19 -8 -6 33 45 46 58 55 53 160 203 186 266 21 51 10 41 -21 -18z"/>
<path d="M3205 6688 c-3 -18 -4 -186 -3 -373 l3 -340 150 2 c83 1 212 2 288 2
l137 1 0 60 0 60 -222 0 -223 0 2 304 2 304 -37 6 c-77 12 -91 9 -97 -26z"/>
<path d="M4040 6348 l0 -368 305 0 305 0 0 60 0 60 -240 0 -240 0 0 95 0 95
208 2 207 3 3 58 3 57 -211 0 -210 0 0 90 0 90 223 1 c122 0 229 3 237 7 17 8
22 40 14 90 l-5 34 -300 -4 -299 -3 0 -367z"/>
<path d="M4946 6683 c-3 -21 -6 -188 -6 -370 l0 -333 288 0 287 0 2 60 1 60
-221 2 -222 3 -3 308 -2 307 -59 0 -58 0 -7 -37z"/>
<path d="M5984 6563 c-116 -241 -274 -575 -274 -580 0 -2 32 -3 71 -1 l71 3
36 83 35 82 192 0 192 0 35 -82 36 -83 77 -3 c42 -2 75 1 73 5 -2 4 -13 28
-25 53 -36 79 -109 231 -168 355 -56 118 -79 167 -125 273 l-24 52 -63 0 -63
0 -76 -157z m204 -145 c34 -73 62 -136 62 -140 0 -5 -61 -8 -135 -8 -74 0
-135 2 -135 5 0 16 130 275 137 275 5 0 37 -60 71 -132z"/>
<path d="M1867 6703 c-4 -3 -7 -172 -7 -375 l0 -369 68 3 67 3 3 373 3 372
-64 0 c-35 0 -67 -3 -70 -7z"/>
<path d="M2360 6340 l0 -370 286 2 287 3 0 58 0 58 -222 -1 -221 -1 0 311 0
310 -65 0 -65 0 0 -370z"/>
<path d="M5680 5673 c0 -22 4 -23 70 -23 l70 0 0 -155 0 -155 25 0 25 0 0 150
0 150 49 0 c62 0 81 7 81 31 0 17 -12 18 -160 21 l-160 3 0 -22z"/>
<path d="M3090 5682 c-21 -3 -37 -28 -113 -179 -49 -96 -86 -177 -83 -180 3
-3 16 -3 30 1 17 4 30 19 42 51 l19 45 106 0 106 0 23 -50 c23 -50 31 -55 60
-42 12 6 -3 41 -75 182 -83 161 -92 175 -115 172z m43 -137 c20 -42 37 -78 37
-80 0 -3 -36 -5 -80 -5 -44 0 -80 2 -80 5 0 10 75 155 80 155 3 0 22 -34 43
-75z"/>
<path d="M3467 5683 c-4 -3 -7 -86 -7 -183 l0 -177 25 5 c24 4 25 8 25 68 l0
64 70 0 69 0 52 -70 c47 -62 55 -69 78 -63 14 3 27 6 28 7 1 1 -22 30 -51 66
l-53 65 28 12 c36 15 61 54 62 97 2 87 -50 116 -212 116 -59 0 -111 -3 -114
-7z m244 -54 c24 -12 40 -49 32 -77 -8 -31 -46 -42 -143 -42 l-90 0 0 65 0 65
91 0 c50 0 99 -5 110 -11z"/>
<path d="M3950 5665 c0 -24 2 -25 70 -25 l70 0 0 -155 0 -155 25 0 25 0 0 155
0 154 68 3 c61 3 67 5 70 26 l3 22 -165 0 -166 0 0 -25z"/>
<path d="M4712 5513 l3 -178 110 0 c99 0 115 3 155 25 101 57 121 189 42 274
-43 46 -80 56 -202 56 l-110 0 2 -177z m199 127 c19 0 42 -12 67 -34 34 -32
37 -39 37 -89 0 -99 -49 -135 -182 -136 l-73 -1 0 129 0 130 33 4 c17 3 45 3
61 1 16 -2 42 -4 57 -4z"/>
<path d="M5347 5628 c-62 -112 -148 -290 -143 -295 15 -15 54 10 72 48 l20 41
103 3 103 2 18 -42 c21 -50 29 -56 57 -49 20 5 15 17 -63 177 -71 146 -87 172
-108 175 -20 3 -29 -7 -59 -60z m121 -153 c-3 -3 -37 -5 -76 -3 l-71 3 37 82
37 81 40 -78 c21 -44 36 -82 33 -85z"/>
<path d="M6272 5678 c-19 -24 -173 -340 -168 -345 3 -3 16 -3 29 1 15 3 30 20
43 48 12 28 25 43 37 42 9 0 56 -1 105 -2 l87 -2 17 -40 c14 -34 21 -40 47
-40 l30 0 -22 38 c-12 20 -25 39 -29 40 -4 2 -8 7 -8 12 0 4 -15 33 -34 65
-20 32 -32 63 -29 72 5 12 3 14 -7 8 -8 -5 -11 -4 -6 3 3 6 -4 34 -16 61 -17
39 -27 51 -44 51 -12 0 -26 -6 -32 -12z m5 -70 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z m87 -102 l15 -36 -80 0 c-76 0 -89 5 -70 26 15 16 25
58 11 49 -7 -4 -5 6 5 24 9 18 20 29 26 25 6 -3 13 4 16 16 5 20 9 17 34 -23
15 -25 35 -62 43 -81z"/>
<path d="M1875 5665 c-71 -38 -86 -105 -34 -149 17 -14 34 -26 37 -26 41 0
189 -32 200 -44 20 -20 8 -60 -23 -74 -42 -19 -133 -15 -183 9 -39 19 -45 20
-59 7 -13 -14 -12 -18 12 -36 55 -44 196 -53 265 -17 67 35 71 128 8 161 -17
9 -71 22 -120 29 -94 14 -118 26 -118 56 0 52 133 73 203 31 34 -20 36 -20 52
-2 15 17 14 19 -22 41 -49 31 -172 39 -218 14z"/>
<path d="M2330 5500 l0 -180 25 0 25 0 0 137 0 137 66 -97 c36 -53 69 -97 74
-97 11 0 58 55 111 130 l44 63 3 -136 3 -137 24 0 25 0 0 180 0 180 -24 0
c-19 0 -39 -20 -91 -91 -37 -51 -69 -98 -72 -105 -3 -8 -9 -14 -13 -14 -4 0
-39 47 -76 105 -60 92 -72 105 -96 105 l-28 0 0 -180z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
